import { render, staticRenderFns } from "./StffEdit.vue?vue&type=template&id=cabf18c8&scoped=true&"
import script from "./StffEdit.vue?vue&type=script&lang=js&"
export * from "./StffEdit.vue?vue&type=script&lang=js&"
import style0 from "./StffEdit.vue?vue&type=style&index=0&id=cabf18c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabf18c8",
  null
  
)

export default component.exports